import moment from "moment";
import {connect} from "redux-vue";
import * as notificationsActions from "../actions/notifications";

const Notifications = {
  /**
   *
   */
  props: [
    'notifications',
    'handleMenuDismiss',
    'fetchNotifications',
    'dismissNotification'
  ],

  /**
   *
   */
  methods: {
    onDismiss(id) {
      return async () => {
        await this.dismissNotification(id);
        //this.fetchNotifications();
      }
    },
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    return (
      <div class="bg-white shadow-xs text-lg text-gray-900 h-screen lg:h-auto lg:max-h-90screen overflow-y-auto">
        <transition-group name="list" tag="ul">
          <li key="header" class="sticky top-0 bg-white px-5 py-1 flex items-center border-b border-gray-400">
            <button onClick={this.handleMenuDismiss} class="focus:outline-none mr-3">
              <i class="mdi mdi-chevron-left text-3xl"></i>
            </button>
            <div class="font-bold text-sm">
              {this.$t('nav.notifications')}
            </div>
          </li>
          {this.notifications.collection.map(x => (
            <li key={x.id} class="border-b">
              <div class="flex border-l-4 border-teal-400 w-full">
                <div class="w-12 h-12 rounded-full mx-3 bg-orange-400 self-center"></div>
                <div class="flex-1 py-3">
                  <div class="flex justify-between leading-loose">
                    <strong class="text-sm">
                      {x.data.category}
                    </strong>
                    <small class="text-xs text-gray-600">
                      {moment(x.created_at).format("H:mm on D MMM YYYY")}
                    </small>
                  </div>
                  <p class="text-xs text-gray-600">
                    {x.data.text}
                  </p>
                </div>
                <div class="w-10 bg-gray-200 hover:bg-gray-100 ml-6">
                  <div onClick={this.onDismiss(x.id)} class="flex items-center justify-center cursor-pointer h-full">
                    <i class="mdi mdi-close text-2xl text-gray-600"></i>
                  </div>
                </div>
              </div>
            </li>
          ))}
          {this.notifications.collection.length === 0 && (
            <li key="empty" class="bg-teal-100">
              <p class="p-5 text-center text-sm text-teal-900">
                You have not received any recent notifications. Check back often for content updates and
                more ways to get the most out of the app.
              </p>
            </li>
          )}
        </transition-group>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    notifications: state.notifications
  };
}

function mapActionToProps(dispatch) {
  return {
    fetchNotifications: () => dispatch(notificationsActions.fetchNotifications()),
    dismissNotification: (id) => dispatch(notificationsActions.dismissNotification(id))
  };
}

export default connect(mapStateToProps, mapActionToProps)(Notifications);
